<template>
  <span class="number-board">
    <template v-for="(num, i) in numbers">
      <scroll-number
        v-if="/\d/.test(num)"
        :key="i + '_' + num"
        :val="Number(num)"
        :preNum="Number(preNumbers[i] || 0)"
      ></scroll-number>
      <span v-else :key="i + '_' + num">{{ num }}</span>
    </template>
  </span>
</template>
<script>
import ScrollNumber from './number'
import { util } from '../../utils'

function splitNumber (number) {
  const num = Number(number)
  if (num > 10000) {
    return util.toThousands((number / 10000).toFixed(2)) + '万'
  }
  return String(number)
}
export default {
  name: 'NumberBoard',
  components: {
    ScrollNumber
  },
  props: {
    val: {
      type: Number
    }
  },
  data () {
    return {
      preNumbers: [],
      numbers: []
    }
  },
  watch: {
    val (val, preVal) {
      this.preNumbers = splitNumber(preVal).split(/\s*/)
      this.initNum()
    }
  },
  mounted () {
    this.initNum()
  },
  methods: {
    initNum () {
      const numbers = String(splitNumber(this.val)).split(/\s*/)
      this.numbers = numbers
    }
  }
}
</script>
<style lang="sass">
.number-board
  font-size: inherit !important
  white-space: nowrap
</style>
